/* eslint-disable */
import React, { useEffect, useState, useContext, useMemo } from "react";

// MRT
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const ActivityList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const {
    reloadActivityList,
    setReloadActivityList,
    showActivityNameColumn,
    showActivityCourseColumn,
    showActivityCodeColumn,
    showActivityStartDateColumn,
    showActivityEndDateColumn,
    showActivityAudienceColumn,
    setEditActivityData,
    showActivityObservationColumn,
    showActivityDurationColumn,
    showActivityPreparationTimeColumn,
    showActivityMountingTimeColumn,
    showActivityDismantleTimeColumn,
    showAmbActivityCodeColumn,
    setShowAmbActivityCodeColumn,
    searchActivityName,
    searchActivityCode,
    searchActivityCourse,
    searchActivityLot,
    searchActivityMaterialKits,
    searchActivityType,
    searchActivityEducators,
    screenHeight,
  } = useContext(GlobalProvider);

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t } = useTranslation(); //for translation

  // default user data ------------------------------------
  const [activityData, setActivityData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return activityData.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : activityData;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Activity.xlsx");
  };

  //function for get all activity
  const getAllActivityList = async (currentSearch = search) => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_ACTIVITY + `?token=${token}`;

      //search by name
      if (searchActivityName != "") {
        requestUrl = requestUrl + `&activityname=${searchActivityName}`;
      }

      //search by code
      if (searchActivityCode != "") {
        requestUrl = requestUrl + `&activitycode=${searchActivityCode}`;
      }

      //search by courses
      if (searchActivityCourse.length > 0) {
        requestUrl = requestUrl + `&activitycourse=${searchActivityCourse}`;
      }

      //search by lot
      if (searchActivityLot.length > 0) {
        requestUrl = requestUrl + `&activitylot=${searchActivityLot}`;
      }

      //search by material kits
      if (searchActivityMaterialKits.length > 0) {
        requestUrl = requestUrl + `&activitymaterialkits=${searchActivityMaterialKits}`;
      }

      //search by activity type
      if (searchActivityType.length > 0) {
        requestUrl = requestUrl + `&activitytype=${searchActivityType}`;
      }

      //search by educators
      if (searchActivityEducators.length > 0) {
        requestUrl = requestUrl + `&activityeducators=${searchActivityEducators}`;
      }

      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }

      console.log("requestUrl of activity list=========>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response activity list========>", response);

      if (response.status) {
        setActivityData(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <div className="kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center justify-content-between">
          <span>{dataItem.name}
            {(dataItem.beneficiaryuploads?.length > 0 || dataItem.uploads?.length > 0) && (
              <span className=" ms-2 me-2 material-symbols-outlined icon-md">attach_file</span>
            )}

          </span>
          <div className="d-flex align-items-center gap-2">
            <Link to="#" className="ml-auto edit_icon">
              <span
                className={`d-block material-symbols-outlined icon-md ${
                  dataItem.zipcode ? "text-green" : "text-danger"
                }`}
              >
                location_on
              </span>
            </Link>
            <Link
              to="#saveActivityPopup"
              data-bs-toggle="offcanvas"
              className="ml-auto edit_icon"
            >
              <span
                className="d-block material-symbols-outlined icon-md"
                onClick={() => {
                  setEditActivityData(dataItem._id);
                }}
              >
                edit
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const tableColumns = useMemo(() => withStrictFilter((() => {
    const cols = [];

    if (showActivityNameColumn) {
      cols.push({
        id: "name",
        accessorKey: "name",
        header: t("Name of the Activity"),
        Cell: ({ row }) => nameHTML({ dataItem: row.original }),
        size: 380,
      });
    }
    if (showActivityCourseColumn) {
      cols.push({
        id: "course.name",
        accessorFn: (row) => row.course?.name ?? "",
        header: t("Course"),
        size: 200,
      });
    }
    if (showActivityCodeColumn) {
      cols.push({
        id: "activitycode",
        accessorKey: "activitycode",
        header: t("Code"),
        size: 200,
      });
    }

    // Always show Amb Id column (matches the non-search Grid)
    cols.push({
      id: "ambactivityid",
      accessorKey: "ambactivityid",
      header: t("Amb Id"),
      size: 200,
    });

    if (showActivityStartDateColumn) {
      cols.push({
        id: "activitystartdate",
        accessorKey: "activitystartdate",
        header: t("Start Deadline"),
        size: 200,
      });
    }
    if (showActivityDurationColumn) {
      cols.push({
        id: "activityduration",
        accessorKey: "activityduration",
        header: t("Duration"),
        size: 200,
      });
    }
    if (showActivityPreparationTimeColumn) {
      cols.push({
        id: "preparationtime",
        accessorKey: "preparationtime",
        header: t("Preparation time"),
        size: 150,
      });
    }
    if (showActivityMountingTimeColumn) {
      cols.push({
        id: "mountingtime",
        accessorKey: "mountingtime",
        header: t("Mounting time"),
        size: 150,
      });
    }
    if (showActivityDismantleTimeColumn) {
      cols.push({
        id: "dismantletime",
        accessorKey: "dismantletime",
        header: t("Dismantle time"),
        size: 150,
      });
    }
    if (showActivityEndDateColumn) {
      cols.push({
        id: "activityenddate",
        accessorKey: "activityenddate",
        header: t("End Deadline"),
        size: 150,
      });
    }
    if (showActivityAudienceColumn) {
      cols.push({
        id: "specialaudience",
        accessorKey: "specialaudience",
        header: t("Specific Audience"),
        size: 150,
      });
    }
    if (showActivityObservationColumn) {
      cols.push({
        id: "observation",
        accessorKey: "observation",
        header: t("Observation"),
        size: 200,
      });
    }

    return cols;
  })()), [
    showActivityNameColumn,
    showActivityCourseColumn,
    showActivityCodeColumn,
    showActivityStartDateColumn,
    showActivityEndDateColumn,
    showActivityAudienceColumn,
    showActivityObservationColumn,
    showActivityDurationColumn,
    showActivityPreparationTimeColumn,
    showActivityMountingTimeColumn,
    showActivityDismantleTimeColumn,
    activityData,
  ]);

  //search use effect
  useEffect(() => {
    if (
      searchActivityName != "" ||
      searchActivityCode != "" ||
      searchActivityCourse.length > 0 ||
      searchActivityLot.length > 0 ||
      searchActivityMaterialKits.length > 0 ||
      searchActivityType.length > 0 ||
      searchActivityEducators.length > 0
    ) {
      getAllActivityList();
    }
  }, [
    searchActivityName,
    searchActivityCode,
    searchActivityCourse,
    searchActivityLot,
    searchActivityMaterialKits,
    searchActivityType,
    searchActivityEducators,
  ]);

  /* hook to reload list */
  useEffect(() => {
    if (reloadActivityList) {
      getAllActivityList();
      setReloadActivityList(false);
    }
  }, [reloadActivityList]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllActivityList();
    }
  }, [responseReceived]);

  /* hook to hit exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, activityData]);

  /* Reset selection when activity list changes (after delete/reload) */
  useEffect(() => {
    setRowSelection({});
  }, [activityData]);

  return (
    <div className="activity_table">
      {/* Hidden checkboxes so ActivityHeader deleteActivity can detect selected rows */}
      <div style={{ display: "none" }}>
        {activityData.map((activity) => (
          <input
            key={activity._id}
            type="checkbox"
            filtername="selectActivityRecord"
            value={activity._id}
            checked={!!rowSelection[activity._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      <div className="table-responsive">
        <MaterialReactTable
          {...defaultTableConfig}
          enableGlobalFilter
          globalFilterFn="strictContains"
          columns={tableColumns}
          data={activityData}
          enableSorting
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          getRowId={(row) => row._id}
          state={{ rowSelection, isLoading }}
          renderLoadingOverlay={() => null}
          muiLinearProgressProps={{ sx: { display: 'none' } }}
          muiCircularProgressProps={{ sx: { display: 'none' } }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
        />
      </div>
    </div>
  );
};

export default ActivityList;
